import YandexGoals from 'www/modules/YandexGoals'

new YandexGoals({
  dataName: 'data-town-menu-yandex-goals',
})
